import React, { useState, Fragment, useEffect } from "react";
import Radio from '@mui/material/Radio';
import { v4 as uuidv4 } from "uuid";
import Carroussel from "./components/Carroussel";
import Clasica from "./components/Clasica";
import Gold from "./components/Gold";
import Platinum from "./components/Platinum";
import Gracias from "./components/Gracias";
import { useSelector } from "react-redux";
import Beneficios from "./components/Beneficios";

const App = () => {

  const [name, setName] = useState("");
  const [cedula, setCedula] = useState("");
  const [apellido, setApellido] = useState("");
  const [email, setEmail] = useState("");
  const [celular, setCelular] = useState("");
  const [value,onChange]=useState(15000);
  const [selectedValue, setSelectedValue] = useState("");
  const [gracias, setGracias] = useState(0);

  const tarjetaestado = useSelector((state) => state.appState.tarjeta[0]);

  console.log(tarjetaestado)

  const handleName = (event) => {
    setName(event.target.value);
  }
  const handleCedula = (event) => {
    setCedula(event.target.value);
  }
  const handleApellido = (event) => {
    setApellido(event.target.value);
  }
  const handleEmail = (event) => {
    setEmail(event.target.value);
  }
  const handleCelular = (event) => {
    setCelular(event.target.value);
  }
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };


  useEffect(() => {
    if(tarjetaestado === 0) {
      onChange(15000);
    }else if(tarjetaestado === 1) {
      onChange(60000);
    }else if(tarjetaestado) {
      onChange(100000);
    }
        
  }, [tarjetaestado]);




const continuar = () => {
  var error = document.querySelector(".error");
  if(!name){
      error.classList.add("activo");
      setTimeout(() => {
        error.classList.remove("activo");
      }, "4000");
  }else if(!cedula){
      error.classList.add("activo");
      setTimeout(() => {
        error.classList.remove("activo");
      }, "4000");
  }else if(!apellido){
    error.classList.add("activo");
    setTimeout(() => {
      error.classList.remove("activo");
    }, "4000");
  }else if(!email){
    error.classList.add("activo");
    setTimeout(() => {
      error.classList.remove("activo");
    }, "4000");
  }else if(!celular){
    error.classList.add("activo");
    setTimeout(() => {
      error.classList.remove("activo");
    }, "4000");
  }else{
    error.classList.remove("activo");
    setGracias(1);
  }
}

const cards = [
  {
    key: uuidv4(),
    content: <Clasica />
  },
  {
    key: uuidv4(),
    content: <Gold />
  },
  {
    key: uuidv4(),
    content: <Platinum />
  }
]; 


  return (
    <Fragment>
    <div className="container">
          <div id="header">
            <div id="logo"><img src="img/logo.png" alt="logo"></img></div>
            <div id="titulo"><img src="img/titulo.png" alt="titulo"></img></div>
            <div id="gif"><img src="img/gif.gif"></img></div>
            <img src="img/fondo.jpg" alt="fondo"></img>
            <div id="tarjetas"><img src="img/tarjetas.png" alt="tarjetas"></img></div>
          </div>
          <div className="content">
          <form id="contact_form">
          <label for="nombre">Nombre:</label><br></br>
            <input type="text" id="nombre" name="nombre" tabIndex="2" onChange={handleName} />
            <br></br><br></br>
            <label for="apellido">Apellido:</label><br></br>
            <input type="text" id="apellido" name="apellido" tabIndex="3" onChange={handleApellido} />
            <br></br><br></br>
            <label for="email">Email:</label><br></br>
            <input type="email" id="email" name="email" tabIndex="4" onChange={handleEmail} />
            <br></br><br></br>
            <label for="celular">Celular:</label><br></br>
            <input type="number" id="celular" name="celular" tabIndex="5" onChange={handleCelular}/>
            <br></br><br></br>
            <label for="cedula">Documento de identidad:</label><br></br>
            <input type="number" id="cedula" name="cedula" tabIndex="1" onChange={handleCedula} />
            <p>*En caso de ya ser socio ConnectMiles<br></br> registrese con el mismo email.</p>
            <div className="clear"></div>
            <div id="socio">
              ¿Ya sos socio ConnectMiles? 
              <Radio checked={selectedValue === 'd'} onChange={handleChange} value="d" name="socio" />
            </div>
            <br></br>
            <div id="ingresos">
              <label>Ingresos individuales:</label><br></br>
              <div className="ingreso">{value}</div>
              <div className="range">
                <input type="range" min="0" max="500000" step="1000" value={value} onChange={({ target: { value: radius } }) => { onChange(radius);}} />
              </div>
            </div>
            
            <div className="clear"></div>
          </form>
          <div id="tarjetas_select">
            <h2>Con esta tarjeta no parás de disfrutar.</h2>
            <div className="tarejtas_carroussel">
              <Carroussel
                cards={cards}
                height="200px"
                width="70%"
                margin="0 auto"
                offset={2}
                showArrows={false}
                />
          </div>
          <Beneficios beneficio={tarjetaestado} />
            <div id="la_quiero" onClick={continuar}>La quiero!</div>
            <div className="clear"></div>
            <div className="error">Complete todos los campos.</div>
          </div>
        </div>
    </div>
     {
      gracias === 1 ?
      <Gracias tarjeta={tarjetaestado} />
      :
      null
    }
    </Fragment>
  );
}

export default App;
